import React, { PureComponent, useEffect, useState } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { Divider } from 'antd'
import {
  Div, P, H4,
} from 'konsys-ui'
import {
  ContainerWrapper, ImageLogo, MenuIcon, MenuItem, Drawer, Iconn,
} from './styled'
import logo from '../../images/tews-logo.png'
import { getAccessToken, removeAccessToken } from '../../utils/local-data-service'
import history from '../../history'

const logoutHandler = () => {
  removeAccessToken()
  window.location = '/login'
}

const menulist = [
  <Link to='/profile' key={1}>
    <MenuItem>Account</MenuItem>
    <Divider />
  </Link>,
  <Link to='/' key={2}>
    <MenuItem>Reserve</MenuItem>
    <Iconn icon='far fa-users' />
    <Divider />
  </Link>,
  <Div key={3}>
    <MenuItem key={3} onClick={() => (getAccessToken() ? logoutHandler() : history.push('/login'))}>{getAccessToken() ? 'Log out' : 'Login'}</MenuItem>
    <Divider />
  </Div>,
]

const Container = ({ children, profile, email }) => {
  const [drawer, setDrawer] = useState(false)

  return (
    <ContainerWrapper>
      <Div textAlign='right' onClick={() => setDrawer(!drawer)}>
        <MenuIcon className="fas fa-ellipsis-v"></MenuIcon>
      </Div>
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setDrawer(false)}
        visible={drawer}
      >
        { getAccessToken() ? menulist : _.slice(menulist, 1, 3) }
        <Div display='flex' justifyContent='center' alignItems='center'>
          <p>v.1.0.2</p>
        </Div>
      </Drawer>
      <Div display='flex' justifyContent='space-between' alignItems='center' margin='32px 0 56px'>
        {
          profile
            ? <Div>
              <P letterSpacing='0.75px' display='block' black={true}>{email}</P>
              <H4 letterSpacing='1px' margin='8px 0 0' black={true}>PROFILE</H4>
            </Div>
            : <Div>
              <P letterSpacing='0.75px' display='block' black={true}>TEW’S BARBER</P>
              <H4 letterSpacing='1px' margin='8px 0 0' black={true}>BOOKING</H4>
            </Div>
        }
        <Div>
          <ImageLogo src={logo} />
        </Div>
      </Div>
    { children }
    </ContainerWrapper>
  )
}

export const Main = ({ children }) => (
  <div>
    { children }
  </div>
)

export default Container



// WEBPACK FOOTER //
// ./src/components/container/index.jsx